"use client";

import React from "react";

import { Button, TextField } from "@repo/design-system";
import { Search } from "@repo/design-system/icons";
import { useTranslation } from "react-i18next";

import { useNotFoundSearch } from "./hooks";

export const NotFoundSearch = () => {
  const { t } = useTranslation(["message", "button"]);
  const { value, setValue, submit, onKeyDown, inputRef } = useNotFoundSearch();

  const placeholder = t("notfound_search_placeholder", { ns: "message" });

  return (
    <div className="flex w-full max-w-md flex-col items-stretch gap-3 sm:flex-row">
      <TextField
        ref={inputRef}
        value={value}
        onChange={setValue}
        onKeyDown={onKeyDown}
        aria-label={placeholder}
        placeholder={placeholder}
        className="w-full"
        fieldGroupClassName="h-12 max-h-12 min-h-12 w-full rounded-md border border-borderTertiary bg-backgroundTertiary"
        inputClassName="h-full! w-full! bg-transparent text-base text-contentPrimary"
        icon={<Search width={18} height={18} />}
      />
      <Button
        variant="primary"
        onPress={submit}
        className="h-12 w-full whitespace-nowrap rounded-md px-6 text-base font-medium sm:w-auto">
        {t("search", { ns: "button" })}
      </Button>
    </div>
  );
};
